import { buildLoadingSkeletonSource } from '@next-adapter/generators/emitted-helpers.js'

export function generatePageSkeleton(pascal: string, label: string): string {
  return buildLoadingSkeletonSource(`${pascal}SubmissionsPageSkeleton`, label)
}
